import React, { useContext, useEffect } from 'react'
import { SettingProviderStep3 } from "app/React/Components/Form/Step3/SettingContextStep3"
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function SettingContainerStep3({ children }) {
  const {
    checkedEquipmentRequirements,
    currentVariant,
    disabledEquipmentRequirements,
    setCheckedEquipmentRequirements,
    setDisabledEquipmentRequirements,
  } = useContext(ConfiguratorContext)

  const isExcluded = (option) => Object.values(disabledEquipmentRequirements.excludes).flat().includes(option)
  const isDisabled = (option) => isExcluded(option) || isRequired(option)
  const isRequired = (option) => {
    if (disabledEquipmentRequirements.required.hasOwnProperty(option)) {
      let results = Object.values(disabledEquipmentRequirements.required[option]).filter(function (optionValue) {
        let options = optionValue.filter(function (oValue) {
          return Object.keys(checkedEquipmentRequirements).includes(oValue)
        })
        return options.length === optionValue.length
      })

      return results.length === 0;
    }
  }

  const markExcluded = (excludedBy, ids) => {
    disabledEquipmentRequirements.excludes[excludedBy] = ids

    setDisabledEquipmentRequirements(disabledEquipmentRequirements)
  }


  const markNotExcluded = (id) => {
    delete disabledEquipmentRequirements.excludes[id]

    setDisabledEquipmentRequirements(disabledEquipmentRequirements)
  }

  const markUnchecked = (id) => {
    delete checkedEquipmentRequirements[id]
    setCheckedEquipmentRequirements(checkedEquipmentRequirements)

    if (Object.keys(disabledEquipmentRequirements.excludes).includes(id)) {
      markNotExcluded(id)
    }
  }

  const contextObject = {

    isDisabled: isDisabled,

    isExcluded: isExcluded,

    isRequired: isRequired,

    getCheckedForSetting: (settingId) => {
      return Object.keys(checkedEquipmentRequirements).filter(function (key) {
        return checkedEquipmentRequirements[key] === settingId
      })
    },

    markExcluded: markExcluded,

    markNotExcluded: markNotExcluded,

    markNotRequired: (id) => {},

    markChecked: (id, settingId, override = false) => {
      // Maybe this is broken?!?
      let checkedEntries = Object.entries(checkedEquipmentRequirements)

      // This setting is required so remove all other options
      if (override) {
        for (let i = 0; i < checkedEntries.length; i++) {
          if (String(checkedEntries[i][1]) === String(settingId)) {
            checkedEntries.splice(i, 1)
          }
        }
      }

      const newChecked = Object.fromEntries(checkedEntries)

      if (!Object.keys(newChecked).includes(String(id))) {
        newChecked[String(id)] = String(settingId)
        setCheckedEquipmentRequirements(newChecked)
      }
    },

    markUnchecked: markUnchecked,

    isChecked: (id) => {
      if (isDisabled(id) && Object.keys(checkedEquipmentRequirements).includes(id)) {
        markUnchecked(id)
        return false
      }

      return Object.keys(checkedEquipmentRequirements).includes(id)
    }
  }

  useEffect(() => {
    setDisabledEquipmentRequirements({
      required: currentVariant?.steps['3']?.equipmentRequirements ?? {},
      excludes: {}
    })

    Object.entries(checkedEquipmentRequirements).forEach(([optionId, settingsId]) => {
      const options = currentVariant.steps['3']?.settings?.[settingsId]?.options

      if (!options) {
        return
      }

      const option = options.find(option => option.id == optionId)

      if (!option) {
        return
      }

      markExcluded(parseInt(optionId), option.option_selectable_rules_option)
    })
  }, [])

  return (
    <div>
      <SettingProviderStep3 value={contextObject}>
        {children}
      </SettingProviderStep3>
    </div>
  )
}
